/* eslint-disable import/prefer-default-export */
import createAxiosThunk from 'store/createAxiosThunk';

import { axiosInstance as selectAxios } from '../config/selectAxios';

/**
 * This thunk serves two purposes:
 * 1. It needs to verify that the access token is valid
 * 2. It needs to fetch the session data and return it to the reducer
 */
export const initializeSession = createAxiosThunk('initializeSession', async (args, thunkApi) => {
  const { getState } = thunkApi;
  const state = getState();

  const axios = selectAxios(state);
  const { integrationToken = null } = args;

  const headers = { 'X-Integration-Token': integrationToken };

  const response = await axios.get(`/init/?include_session=true`, { headers });

  return response.data;
});
